export interface IWebNotification {
  messageId: number;
  messageType: number;
  messageTitle: string;
  messageString: string;
  customerId: number;
  entityType: string;     // LAYOUT / LAYOUT_STRING / PLANOGRAM
  entityId: string;
  entityPage: string;
  sentOn: number;
  read: boolean;
}

export class WebNotification implements IWebNotification {
  messageId: number;
  messageType: number;
  messageTitle: string;
  messageString: string;
  customerId: number;
  entityType: string;     // LAYOUT / LAYOUT_STRING / PLANOGRAM / DEVICE
  entityId: string;
  entityPage: string;
  sentOn: number;
  read: boolean;

  constructor(noti?: IWebNotification) {
    if (noti) Object.keys(noti).map(k => { this[k] = noti[k] })  // assign notification object into class instance.
    if(this.read != null && typeof this.read != 'boolean') this.read = JSON.parse(this.read)
    
    for (let field of ['messageId', 'messageType', 'customerId', 'sentOn']) {
      if(this[field] != null && typeof this[field] != 'number') this[field] = parseInt(this[field], 10)
    }
  }

  getLinkAndTitle() {
    // console.log("Call getLinkAndTitle > this -", this);
    if (this.messageType == null) return [];

    let _link, _linkQuery, _title, _linkType
    switch (this.messageType) {
      case 1:
        if (this.entityType == "LAYOUT") _linkType = 'layout-preview'
        if (this.entityType == "LAYOUT_STRING") _linkType = 'layoutString-preview'
        if (this.entityType == "PLANOGRAM") _linkType = 'planogram-preview'
        break;

      case 2:
        if (this.entityType == "LAYOUT") _linkType = 'layout-edit'
        if (this.entityType == "LAYOUT_STRING") _linkType = 'layoutString-edit'
        if (this.entityType == "PLANOGRAM") _linkType = 'planogram-edit'
        break;

      case 3:
        if (this.entityType == "LAYOUT") _linkType = 'layout-approval'
        if (this.entityType == "LAYOUT_STRING") _linkType = 'layoutString-approval'
        if (this.entityType == "PLANOGRAM") _linkType = 'planogram-approval'
        break;

      case 5:
        if (this.entityType == "PLANOGRAM") _linkType = 'planogram-preview'
        break;

      case 6:
      case 8:
      case 9:
      case 10:
      case 11:
        if (this.entityType == "DEVICE") _linkType = 'device-view'
        break;

      case 14:
        _linkType = 'organization-setting'
        break;

      case 15:
        _linkType = 'goto-dashboard'
        break;

      case 4:
        if (this.entityType == "PLANOGRAM") _linkType = 'planogram-preview'
        break;
      case 7:  // no link to create
      case 12:  // no link to create
      case 13:  // no link to create
      default:
        // code...
        break;
    }

    switch (_linkType) {
      // preview
      case "layout-preview":
        _link = `/pages/cms/campaign-preview/${this.entityId}`
        _title = 'Preview Campaign'
        break;

      case "layoutString-preview":
        _link = `/pages/cms/campaign-string-preview/${this.entityId}`
        _title = 'Preview Campaign String'
        break;

      case "planogram-preview":
        _link = `/pages/cms/planogram`
        _linkQuery = { previewPlanogramId: this.entityId }
        _title = 'Preview Planogram'
        break;

      // edit
      case "layout-edit":
        _link = `/pages/cms/campaign-edit/${this.entityId}`
        _title = 'Edit Campaign'
        break;

      case "layoutString-edit":
        _link = `/pages/cms/campaign-string-list`
        _linkQuery = { editLayoutStringId: this.entityId }
        _title = 'Edit Campaign String'
        break;

      case "planogram-edit":
        _link = `/pages/cms/planogram-events/${this.entityId}`
        _title = 'Edit Planogram'
        break;

      // approval
      case "layout-approval":
        _link = `/pages/cms/campaign-details/${this.entityId}`
        _title = 'Goto Campaign Approval'
        break;

      case "layoutString-approval":
        _link = `/pages/cms/campaign-string-details/${this.entityId}`
        _title = 'Goto Campaign String Approval'
        break;

      case "planogram-approval":
        _link = `/pages/cms/planogram-details/${this.entityId}`
        _title = 'Goto Planogram Approval'
        break;

      // device-view
      case "device-view":
        _link = `/pages/device/view-device/${this.entityId}`
        _title = 'View Device'
        break;

      // organization-setting
      case "organization-setting":
        _link = `/pages/admin/organization-settings`
        _title = 'Goto Organization Setting'
        break;

      case "goto-dashboard":
        _link = `/pages/dashboard`
        _title = `Goto Dashboard`
        break;

      default:
        // code...
        break;
    }

    return [_link, _linkQuery, _title]
  }

}

export const NonSlientMessageTypes = ["MAKERS_ENTITY_APPROVED", "MAKERS_ENTITY_REJECTED", "ENTITY_WAITING_FOR_APPROVAL",
  "PLANO_READY_TO_GO_LIVE", "PLANO_SUBMITTED_OR_APPROVED", "CONTENT_DOWNLOAD_FAILURE", "LICENSE_RENEWAL",
  "PANEL_UPTIME", "PANEL_DOWNTIME", "DEVICE_UPTIME", "DEVICE_DOWNTIME", "LAYOUT_OR_LAYOUT_STRING_DELETED",
  "PLANO_DELETED", "CUSTOMER_SETUP_PENDING", "CUSTOMER_ONBOARDED"]


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/notification/models/notification.ts